export { DynamicArticleHero } from './DynamicArticleHero';
